export default "__VITE_ASSET__BfXjCRdk__"